export const formatSequence = (code, numero) => {
  const part0 = code.toString().padStart(3, '0');
  const part1 = numero.toString().padStart(3, '0');
  return `${part0}-${part1}`;
};

export const formatAmount = (amount) => {
  const parts = Number(amount).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  return `${integerPart},${decimalPart}`;
};
